import { Modal, Box, Button, CircularProgress } from "@mui/material";
import { DeleteUserModalProps } from "./types";
import { useCallback, useContext, useState } from "react";
import { useBus, useListener } from "react-bus";
import UserApi from "../../../../api/user";
import { AppContext, IAppContext } from "../../../../Contexts/AppContext";

const style = {
	position: "absolute" as "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	textAlign: "center",
	p: 4,
};

export default function DeleteUserModal(props: DeleteUserModalProps) {
	const { userToDelete } = props;
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);

	const bus = useBus();

	const handleOpen = useCallback(() => setOpen(true), []);
	const handleClose = () => setOpen(false);
	const { snackBar, setSnackBar, userContext } = useContext(
		AppContext
	) as IAppContext;

	useListener("openDeleteUserModal", handleOpen);
	const deleteOperation = useCallback(async () => {
		try {
			setLoading(true);
			await UserApi.deleteUser({
				token: localStorage.getItem("accessToken") || "",
				userId: userToDelete?.id || "",
				permissionaryId: userContext?.permissionaryId || "",
			});

			bus.emit("reloadUsersScreenData");
			handleClose();
			setSnackBar({
				...snackBar,
				open: true,
				message: "Usuario eliminado",
				autoHideDuration: 6000,
				severity: "success",
			});
		} catch (error: any) {
			console.error(error);
			setSnackBar({
				...snackBar,
				open: true,
				message: "Error al eliminar el usuario",
				autoHideDuration: 6000,
				severity: "error",
			});
		} finally {
			setLoading(false);
		}
	}, [bus, setSnackBar, snackBar, userContext?.permissionaryId, userToDelete]);

	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'>
			<Box sx={style}>
				<h2 id='modal-modal-title'>
					{loading ? "Eliminando Usuario" : "Eliminar Usuario"}
				</h2>
				{loading ? (
					<CircularProgress size={35} />
				) : (
					<>
						<p id='modal-modal-description'>
							Esta seguro que desea eliminar el usuario {userToDelete?.email} ?
						</p>

						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								marginTop: 2,
							}}>
							<Button
								variant='contained'
								color='error'
								onClick={() => {
									deleteOperation();
								}}>
								Eliminar
							</Button>
							<Button variant='contained' color='primary' onClick={handleClose}>
								Cancelar
							</Button>
						</Box>
					</>
				)}
			</Box>
		</Modal>
	);
}
